import { actionTypes } from './constants';
import { b64toBlob, downloadFile } from 'helpers/download-file-util';
import { apiCallStatus } from 'helpers/constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { getSelectedAsset } from '../selectors';

import { AssetDetailsApi, ComponentApi } from 'api';
import { getChartView, getSelected2DTimestamp, getSelectedTimestamps } from '../VibrationFFTV2/selectors';
import { getSelectedOrganization } from '../SingleChartView/Trend/TrendChart/selectors';
import { getMaintainedTimestamps } from '../VibrationFFTV2/helpers';
import { chartViews } from '../VibrationFFTV2/constants';

const downloadFFTRawDataAction = getApiActionCreator(actionTypes.DOWNLOAD_RAW_DATA);
const getSensorLastCommandAction = getApiActionCreator(actionTypes.GET_SMART_SENSOR_LAST_COMMAND);

export const setSelectedDates = (from, to) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_DATE_SELECTION, dateSelection: { from, to } });
    };
};

export const downloadRawDataV2 = () => {
    return (dispatch, getState) => {
        const state = getState();
        const selectedAsset = getSelectedAsset(state);
        const selectedOrganization = getSelectedOrganization(state);
        const selectedChartView = getChartView(state);
        const maintainedSelectedTimestamps = selectedChartView === chartViews.FFT2D ?
            getSelected2DTimestamp(state) : getSelectedTimestamps(state);
        const selectedTimestamps = getMaintainedTimestamps(maintainedSelectedTimestamps, selectedAsset, selectedOrganization);

        const params = {
            assetId: selectedAsset.id,
            fftTimestamp: selectedTimestamps
        };

        dispatch(downloadFFTRawDataAction(apiCallStatus.LOADING));
        return AssetDetailsApi.downloadRawDataV2(params)
            .then((rawData) => {
                dispatch(downloadFFTRawDataAction(apiCallStatus.SUCCESS));
                downloadFile(rawData.fileName, b64toBlob(rawData.fileContent));
            })
            .catch((err) => {
                dispatch({ ...downloadFFTRawDataAction(apiCallStatus.ERROR, null, err), suppressGlobalNotification: true });
            });
    };
};

// Get last command request data for Load Measurement and collect raw data
export const getSmartSensorLastCommand = (requestType) => {
    return (dispatch, getState) => {
        const state = getState();
        const selectedAsset = getSelectedAsset(state);
        dispatch(getSensorLastCommandAction(apiCallStatus.LOADING));
        return ComponentApi.getSensorLastCommand(selectedAsset.id, requestType)
            .then((response) => {
                dispatch(getSensorLastCommandAction(apiCallStatus.SUCCESS, response));
            })
            .catch((err) => {
                dispatch(getSensorLastCommandAction(apiCallStatus.ERROR, null, err));
            });
    };
};

export const setActiveTab = (activeTab) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_ACTIVE_TAB, activeTab });
    };
};

export const setActiveTrendTab = (multiChart) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SET_ACTIVE_TREND_TAB, multiChart });
    };
};
